import { Component, Input, OnInit } from '@angular/core';
import { FileUploadUtils } from '../FileUploadUtils';

@Component({
    selector: `file-upload-type-icon`,
    templateUrl: `./file-upload-type-icon.component.html`,
    styleUrls: [`./file-upload-type-icon.component.scss`]
})
export class FileUploadTypeIconComponent implements OnInit {
    @Input()
    public file: File;

    public mimeType: string = undefined;

    constructor() {
    }

    public ngOnInit(): void {
        this.mimeType = this.file && (this.file.type || FileUploadUtils.getMimeType(this.file));
    }

    public isIcon(type: 'text' | 'audio' | 'video' | 'image'): boolean {
        return this.mimeType.includes(type);
    }
}
